module.exports = __webpack_public_path__ + "static/media/focus-icon-2.a4da092e.avif";